import axios from "axios";

class Api {
    static manager = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL
    });
}

export default Api;